module.exports = __webpack_public_path__ + "static/img/1059_big.0ec4076.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1059_big.png
// module id = ca7k
// module chunks = 1